import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router'

// modulo personalizado de Rutas Hijas
import { PagesRoutingModule } from './pages/pages.routing';
import { AuthRoutingModule } from './auth/auth.routing';

// unica ruta dentro del modulo de rutas principales
import { NopagefoundComponent } from './404/nopagefound.component';

const routes: Routes = [

  // indicaciones de rutas tomadas:
  // path: '/dashboard' PagesRouting
  // path: '/auth' AuthRouting
  { path: '', redirectTo: '/dashboard', pathMatch: 'full'}, // path de rutas por defecto
  { path: '**', component: NopagefoundComponent},

];


@NgModule({
  imports: [
    RouterModule.forRoot( routes, { useHash: true } ),
    PagesRoutingModule, // modulo de rutas hijas para las Paginas
    AuthRoutingModule // modulo de rutas hijas para Login y Registro
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
